import React from 'react';
import { Table } from 'antd';
import numeral from 'numeral';
import _ from 'lodash';
import { type UsersyncStatisticsFilters, type UsersyncStatisticsTableRow } from '../../../../types/usersyncStatistics';
import { toNumber } from '../../../../helpers/number';

interface UsersyncStatisticsSummaryProps {
  data: UsersyncStatisticsTableRow[];
  filters: UsersyncStatisticsFilters;
}

export const UsersyncStatisticsSummary: React.FC<UsersyncStatisticsSummaryProps> = ({ data, filters }) => {
  const totals = {
    initialRequest: _.sumBy(data, (row) => toNumber(row.initialRequest)),
    eligibleForSync: _.sumBy(data, (row) => toNumber(row.eligibleForSync)),
    syncAttemptGenerated: _.sumBy(data, (row) => toNumber(row.syncAttemptGenerated)),
    callbackReceived: _.sumBy(data, (row) => toNumber(row.callbackReceived)),
    mappingStored: _.sumBy(data, (row) => toNumber(row.mappingStored)),
    dropCount: _.sumBy(data, (row) => toNumber(row.dropCount)),
  };

  const callbackRate =
    totals.syncAttemptGenerated > 0 ? (totals.callbackReceived / totals.syncAttemptGenerated) * 100 : undefined;
  const storeRate = totals.callbackReceived > 0 ? (totals.mappingStored / totals.callbackReceived) * 100 : undefined;
  const endToEndRate = totals.eligibleForSync > 0 ? (totals.mappingStored / totals.eligibleForSync) * 100 : undefined;
  const dropRate = totals.eligibleForSync > 0 ? (totals.dropCount / totals.eligibleForSync) * 100 : undefined;

  const dynamicColumns = filters.groupBy ?? [];
  let columnIndex = 0;

  return (
    <Table.Summary.Row style={{ fontWeight: 'bold' }}>
      <Table.Summary.Cell index={columnIndex++} />
      {(filters.format === 'by_day' || filters.format === 'by_hour') && <Table.Summary.Cell index={columnIndex++} />}
      {dynamicColumns.map((field) => (
        <Table.Summary.Cell key={field} index={columnIndex++} />
      ))}
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.initialRequest).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.eligibleForSync).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.syncAttemptGenerated).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.callbackReceived).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.mappingStored).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {numeral(totals.dropCount).format('0,0')}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {callbackRate !== undefined ? `${numeral(callbackRate).format('0.00')}%` : '-'}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {storeRate !== undefined ? `${numeral(storeRate).format('0.00')}%` : '-'}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {endToEndRate !== undefined ? `${numeral(endToEndRate).format('0.00')}%` : '-'}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={columnIndex++} align="right">
        {dropRate !== undefined ? `${numeral(dropRate).format('0.00')}%` : '-'}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );
};
